























































import { Component, Vue, Prop } from "vue-property-decorator";
import SalesReportPresentationModel from "../presenters/sales-report-presentation-model";

@Component({})
export default class SalesSummary extends Vue {
  @Prop({ required: true }) report!: SalesReportPresentationModel;
}
